import { ArrivalDate } from 'app/components/Placement/PlacementDetails/Edit/Components/ArrivalDate';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { selectEditableRequirementTypes } from '../../../../../../../../../store/redux-store/placement-summary/selectors';
import { useArrivedFieldsetMeta } from '../useArrivedFieldsetMeta';
import { TransportationRow } from './TransportationTable';
import { CustomTooltip } from '@AMIEWEB/Common';

export const TransportationArrivalDate = () => {
  const { t } = useTranslation();
  const { arrivalDate } = useSelector(selectEditableRequirementTypes);
  const fieldsetMeta = useArrivedFieldsetMeta();

  return (
    <TransportationRow
      id="placement-offer-transportation-arrivalDate"
      label={t('placement.profile.summary.offer.transportation.arrivalDate')}
      controlComponent={
        <CustomTooltip disabled={!fieldsetMeta.disabled} tooltipContent={fieldsetMeta.title} placement="bottom-start" arrow={false} isStandardContent>
          <ArrivalDate disabled={fieldsetMeta.disabled} />
        </CustomTooltip>
      }
      requirement={arrivalDate?.requirement}
    />
  );
};
